import { PrimaryButton, ReactIcons } from "@kalyzee/kalyzee-ui";
import { Loading } from "@kalyzee/kast-web-sdk/web-components";
import React from "react";

interface SimpleButtonProps {
    label: string;
    onClick: () => void | Promise<void>;
    backgroundColor?: string;
    color?: string;
    style?: React.CSSProperties;
}

const SimpleButton: React.FC<SimpleButtonProps> = ({
    label,
    onClick,
    backgroundColor = "var(--color-blue-1)",
    color = "white",
    style,
}) => {
    return (
        <PrimaryButton
            onClick={onClick}
            style={{
                borderRadius: 999,
                backgroundColor,
                padding: "0.1em 0.8em",
                color,
                ...style,
            }}
            renderContent={(loading) => (
                <>
                    {label}
                    {loading && <ReactIcons.Spinner style={{ marginLeft: "1em", height: "1em", color: "white" }} />}
                </>
            )}
        />
    );
};

export default SimpleButton;